// The Page feedback nav badge. Kept apart from api.js so the route config can import it
// without pulling the inbox's other queries into the main bundle.
import { useQuery } from '@tanstack/react-query'
import { FEEDBACK_INBOX } from '@/endpoints'
import axios from '@/lib/axios'

/**
 * Open (unresolved) feedback, for the site-admin nav. Refetches at most once a minute.
 * Counted whether or not the `page_feedback` feature flag is on: the inbox stays open to
 * site admins while it is off, so what is still open stays visible.
 */
export function useFeedbackNavBadge() {
    const query = useQuery({
        queryKey: ['feedback', 'inbox', 'summary'],
        queryFn: async () =>
            (await axios.get(`${FEEDBACK_INBOX}summary/`)).data,
        staleTime: 60_000
    })
    return query.data?.open ?? 0
}
